import { render, staticRenderFns } from "./Desktop2.vue?vue&type=template&id=4d858e48&"
import script from "./Desktop2.vue?vue&type=script&lang=js&"
export * from "./Desktop2.vue?vue&type=script&lang=js&"
import style0 from "./Desktop2.vue?vue&type=style&index=0&id=4d858e48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports